import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import { Styled, Container, Flex, Box } from 'theme-ui'
import YouTube from 'react-youtube'
import FlexList from '../components/flex-list'
import SpeakerCard from '../components/speaker-card'
import moment  from 'moment-timezone'
import Helmet from 'react-helmet'
import IconLink from '../components/icon-link'
import useWebShare from 'react-use-web-share'

import {
  Youtube,
  Folder,
  Share2
} from 'react-feather'

export default function SchedulePage({ data }) {
  const schedule = data.scheduleYaml

  const opts = {
    height: '390',
    width: '100%',
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 0,
    },
  }

  let localTimezoneGuess = moment.tz.guess(true);

  let pacificDiff = moment.utc(schedule.datetime).tz('America/Los_Angeles').format('D') - moment.utc(schedule.datetime).format('D')
  let australiaDiff = moment.utc(schedule.datetime).tz('Australia/Melbourne').format('D') - moment.utc(schedule.datetime).format('D')
  let localDiff = moment.utc(schedule. datetime).tz(localTimezoneGuess).format('D') - moment.utc(schedule.datetime).format('D')

  const { isSupported, loading, share } = useWebShare();

  return (
    <Layout>
      <Helmet>
        <style type="text/css">{`
          .youtubeContainer {
            width: 100%;
          }
        `}</style>
      </Helmet>
      <Container>
        <Styled.h1
          sx={{
            mb: 5,
          }}>
          {schedule.title}
        </Styled.h1>
        <Flex
          sx={{
            mx: -3,
            alignItems: 'center',
            flexWrap: 'wrap',
          }}
        >
          <div
            style={{
              width: "100%"
            }}
          >
            <Styled.h3>
              {schedule.date}
            </Styled.h3>
            <FlexList>
              <div
                style={{
                  width: "33%"
                }}
              >
                <Styled.h3>AEST</Styled.h3>
                <p>{moment.utc(schedule.datetime).tz('Australia/Melbourne').format('HH:mm')}{australiaDiff !== 0 && (`(${Math.sign(australiaDiff) ? '+' : '-'}${australiaDiff})`)}</p>
              </div>
              <div
                style={{
                  width: "33%"
                }}
              >
                <Styled.h3>CEST</Styled.h3>
                <p>{moment.utc(schedule.datetime).tz('Europe/Paris').format('HH:mm')}</p>
              </div>
              <div
                style={{
                  width: "33%"
                }}
              >
                <Styled.h3>BST</Styled.h3>
                <p>{moment.utc(schedule.datetime).tz('Europe/London').format('HH:mm')}</p>
              </div>
              <div
                style={{
                  width: "33%"
                }}
              >
                <Styled.h3>EDT</Styled.h3>
                <p>{moment.utc(schedule.datetime).tz('America/New_York').format('HH:mm')}</p>
              </div>
              <div
                style={{
                  width: "33%"
                }}
              >
                <Styled.h3>PDT</Styled.h3>
                <p>{moment.utc(schedule.datetime).tz('America/Los_Angeles').format('HH:mm')}{pacificDiff !== 0 && (`(${pacificDiff})`)}</p>
              </div>
              <div
                style={{
                  width: "33%"
                }}
              >
                <Styled.h3>Local</Styled.h3>
                <p>{moment.utc(schedule.datetime).tz(localTimezoneGuess).format('HH:mm')}{localDiff !== 0 && (`(${localDiff})`)}</p>
              </div>
            </FlexList>
          </div>
          <div
            sx={{
              flex: 'none',
              p: 3,
              width: [ '100%', '100%' ],
            }}>
            <Styled.h2>Description</Styled.h2>
            <Styled.p
              sx={{
                mb: 2
              }}>
              {schedule.description}
            </Styled.p>
            <Flex mx={-2}>
              {schedule.youtubeid && (
                <IconLink href={`https://www.youtube.com/watch?v=${schedule.youtubeid}`}>
                  <Youtube />
                </IconLink>
              )}
              {schedule.slidedeckUrl && (
                <IconLink href={schedule.slidedeckUrl}>
                  <Folder />
                </IconLink>
              )}
              { !loading && isSupported && (
                <Box
                  sx={{
                    display: 'inline-block',
                    p: 2,
                    color: 'inherit',
                    textDecoration: 'none',
                    '&:hover': {
                      color: 'primary',
                    },
                    '& > svg': {
                      display: 'inline-block',
                      verticalAlign: 'middle',
                    }
                  }}
                >
                  <Share2 onClick={share.bind(share, {
                    title: schedule.title,
                    text: schedule.title,
                    url: `/session/${schedule.slug}`
                  })}/>
                </Box>
              )}
            </Flex>
          </div>
          {schedule.youtubeid && (
            <YouTube containerClassName='youtubeContainer' videoId={schedule.youtubeid} opts={opts} />
          )}
        </Flex>
        <Styled.h2>
          Speaker{schedule.speaker.length > 1 ? 's' : ''}
        </Styled.h2>
        <FlexList
          sx={{
            justifyContent: 'center',
          }}>
          {schedule.speaker.map(speaker => {
            if (!speaker.dontshow)
            return (
              <SpeakerCard
                key={speaker.id}
                as='li'
                {...speaker}
              />
            )
          })}
        </FlexList>
      </Container>
    </Layout>
  )
}
export const query = graphql`
query($slug: String!) {
  scheduleYaml(slug: { eq: $slug }) {
    datetime:  date
    date(formatString: "ddd, MMM Do")
    time: date(formatString: "h:mm a")
    title
    description
    youtubeid
    slidedeckUrl
    slug
    speaker {
      id
      name
      bio
      image
      company
      twitter
      github
      linkedin
      url
      dontshow
    }
  }
}
`